export default __webpack_public_path__ + "static/media/timer.d4336d51.mp3";